import { Api } from 'models/services/api';
import { ReadRelationshipsByCategoryIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  categoryId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsByCategoryId($categoryId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsByCategoryIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsByCategoryId: RelationshipCollectionData;
  }
}

class ReadCollectionByCategoryIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsByCategoryId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionByCategoryIdGql };
